import React, { CSSProperties, Ref } from 'react';
import classNames from 'classnames';

import Flex from '@cobalt/react-flex';

import Checkbox from './Checkbox';
import { CheckboxGroupOptionType } from './types';

export interface CheckboxGroupProps {
  value: string[];
  disabled?: boolean;
  options?: Array<string | CheckboxGroupOptionType>;
  truncated?: boolean;
  className?: string;
  style?: CSSProperties;
  prefixCls?: string;
  forwardedRef?: Ref<HTMLInputElement>;
  onChange: (value: string[]) => void;
  onBlur?: () => void;
}

const cls = 'checkbox-group';

export default function CheckboxGroup(props: CheckboxGroupProps) {
  const {
    value,
    disabled = false,
    options = [],
    truncated = true,
    className,
    style,
    prefixCls = 'cobalt',
    onChange,
    onBlur,
  } = props;

  const componentCls = `${prefixCls}-${cls}`;
  const mergeClassNames = classNames(`${componentCls}`, className);

  const handleChange = (key: string, checked: boolean) => {
    const temp = [...value];
    if (checked) {
      temp.push(key);
    } else {
      temp.splice(temp.indexOf(key), 1);
    }

    onChange(temp);
  };

  return (
    <Flex className={mergeClassNames} style={style} direction="column" gap={2}>
      {options.map((option) => {
        if (typeof option === 'string') {
          return (
            <Checkbox
              key={option}
              label={option}
              checked={value.includes(option)}
              disabled={disabled}
              truncated={truncated}
              className={className ? `${className}-item` : undefined}
              prefixCls={prefixCls}
              onChange={(checked) => handleChange(option, checked)}
              onBlur={onBlur}
            />
          );
        } else {
          return (
            <Checkbox
              key={option.value}
              label={option.label}
              checked={value.includes(option.value)}
              disabled={disabled || option.disabled}
              truncated={truncated}
              className={className ? `${className}-item` : undefined}
              style={option.style}
              prefixCls={prefixCls}
              onChange={(checked) => handleChange(option.value, checked)}
              onBlur={onBlur}
            />
          );
        }
      })}
    </Flex>
  );
}
